import { jsx, jsxs } from "react/jsx-runtime";
import { Fragment, forwardRef, useEffect, useState } from "react";
import { useCombinedRefs } from "../../hooks/useCombinedRefs.js";
import { useFloatingElement } from "../../hooks/_internal/useFloatingElement/index.js";
import { Fade } from "../../transitions/fade/Fade.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import { Portal } from "../portal/Portal.js";
import FloatingContainer_module from "./FloatingContainer.module.js";
const FloatingContainer = /*#__PURE__*/ forwardRef(({ anchorRef, open, portal = false, children, className, style, testId, theme, arrow, offset, shift, oppositeAxisPlacement, flip, placement, strategy, contentProps, ...props }, ref)=>{
    const [arrowNode, setArrowNode] = useState();
    const { arrowStyles, styles: floatingStyles, refs: { setFloating: setFloatingRef, setReference: setAnchorRef }, update } = useFloatingElement({
        offset,
        shift,
        flip,
        placement,
        strategy,
        arrowNode,
        oppositeAxisPlacement
    });
    useEffect(()=>{
        setAnchorRef(anchorRef.current);
    }, [
        open,
        setAnchorRef,
        anchorRef
    ]);
    const Wrapper = portal ? Portal : Fragment;
    return /*#__PURE__*/ jsx(Wrapper, {
        children: /*#__PURE__*/ jsxs(Fade, {
            timeout: 100,
            visible: open,
            className: combineClasses(className, FloatingContainer_module.container),
            style: {
                ...floatingStyles,
                ...style
            },
            ref: useCombinedRefs(setFloatingRef, ref),
            onEntering: ()=>setTimeout(()=>update()),
            "data-testid": testId,
            "data-theme": theme,
            ...props,
            children: [
                /*#__PURE__*/ jsx("div", {
                    ...contentProps,
                    className: combineClasses(FloatingContainer_module.content, contentProps?.className),
                    children: children
                }),
                arrow && /*#__PURE__*/ jsx("div", {
                    ref: setArrowNode,
                    style: arrowStyles,
                    className: FloatingContainer_module.arrow
                })
            ]
        })
    });
});
FloatingContainer.displayName = 'FloatingContainer';
export { FloatingContainer };
